// @ts-nocheck
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import { History } from "@insite/mobius/utilities/HistoryContext";

export interface ViewedNotesNotificationItem {
    notesId: string;
    hideNotifications?: boolean;
}

const viewedNotesNotificationCacheKey = "viewedFeatureNotesNotifications";
const defaultViewedNotesNotificationLimit = 10;

export function addViewedNotesNotification(notesId: string, limit?: number) {
    if (!notesId || notesId.trim().length === 0) {
        return;
    }

    notesId = notesId.trim();

    let viewedNotesNotification = getViewedNotesNotification();
    const notesIdIndex = viewedNotesNotification.map(o => o.notesId).indexOf(notesId);
    if (notesIdIndex > -1) {
        viewedNotesNotification.splice(notesIdIndex, 1);
    }

    viewedNotesNotification.splice(0, 0, { notesId });
    viewedNotesNotification = viewedNotesNotification.splice(0, limit || defaultViewedNotesNotificationLimit);

    window.localStorage.setItem(viewedNotesNotificationCacheKey, JSON.stringify(viewedNotesNotification));
}

export function clearViewedNotesNotification() {
    window.localStorage.setItem(viewedNotesNotificationCacheKey, "");
}

export function getViewedNotesNotification() {
    if (typeof window === "undefined") {
        return [];
    }

    return (
        JSON.parse(
            window.localStorage.getItem(viewedNotesNotificationCacheKey) || "[]",
        ) as ViewedNotesNotificationItem[]
    ).filter((o: any) => typeof o === "object");
}

const viewNotesNotificationsCacheKey = "viewNotesNotifications";

export function toggleViewNotesNotifications() {
    const viewNotesNotification = getViewNotesNotifications();

    if (viewNotesNotification === undefined) {
        window.localStorage.setItem(viewNotesNotificationsCacheKey, JSON.stringify(false));
        return;
    }

    window.localStorage.setItem(viewNotesNotificationsCacheKey, JSON.stringify(!viewNotesNotification));
}

export function getViewNotesNotifications() {
    if (typeof window === "undefined") {
        return [];
    }

    return JSON.parse(window.localStorage.getItem(viewNotesNotificationsCacheKey) || "true");
}

export const viewNotesClickHandler = (history: History, featureNotesListPage?: PageLinkModel, id?: string) => {
    if (!featureNotesListPage || !id) {
        return;
    }
    history.push(featureNotesListPage.url);
    addViewedNotesNotification(id);
};
